import { useContext, useEffect, useState } from 'react'
import useAxiosRequests from '../hooks/useAxiosRequest'
import { useNavigate } from 'react-router';
import ExternalRoutes from '../config/ExternalRoutes';
import { MessageContext } from '../context/MessageContext';
import LoadingPage from './LoadingPage';

export const PaymentSucceeded = () => {
  const { sendRequest } = useAxiosRequests();
  const navigate = useNavigate();
  const { showSuccess, showError } = useContext(MessageContext);
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const clientSecret = queryParams.get('pm')

    if (clientSecret) {
      setSessionId(clientSecret);
      }
      if(sessionId) {
        sendPaymentDataToBackend(sessionId ?? '');
      }
  }, [sessionId])

  const sendPaymentDataToBackend = async (sessionId) => {
    try {
      if(sessionId) {
        const response = await sendRequest({method:"POST", url: 
            ExternalRoutes.subscription.succeeded,
            body: {
                "session_id": sessionId
            }
        })
        if (!response.status === 'error' || ![200, 201, 202, 204].includes(response.statusCode)) {
            showError(response.message || "Une erreur est survenue lors de l'enregistrement de l'abonnement");
        }
        showSuccess("Abonnement enregistré avec succès.");
        navigate("/");
      }
    } catch (error) {
        showError(error.message || "Une erreur est survenue lors de l'enregistrement de l'abonnement");
        navigate("/");
    }
  }

  return <LoadingPage />
}
